import * as React from 'react';
import * as turf from '@turf/turf';
import LayerParams from './LayerParams';
const useStandClick = (map, onStandClick, baseLayerChangedNum, bound) => {
    // reset selected stand if clicked outside any feature
    React.useEffect(() => {
        if (!map || baseLayerChangedNum === 0)
            return;
        let hoveredStandId = undefined;
        const onMouseMove = (e) => {
            if (!e.features)
                return;
            if (e.features.length > 0) {
                if (hoveredStandId) {
                    map.setFeatureState({ source: LayerParams.sourceId, id: hoveredStandId }, { hover: false });
                }
                hoveredStandId = e.features[0].id;
                map.setFeatureState({ source: LayerParams.sourceId, id: hoveredStandId }, { hover: true });
            }
        };
        const onMouseLeaveHover = () => {
            if (hoveredStandId) {
                map.setFeatureState({ source: LayerParams.sourceId, id: hoveredStandId }, { hover: false });
            }
            hoveredStandId = undefined;
        };
        const onMouseEnter = () => {
            map.getCanvas().style.cursor = 'pointer';
        };
        const onMouseLeave = () => {
            map.getCanvas().style.cursor = '';
        };
        const onClick = (e) => {
            var _a, _b;
            const feature = (_a = e.features) === null || _a === void 0 ? void 0 : _a[0];
            if (!feature || ((_b = feature.properties) === null || _b === void 0 ? void 0 : _b.disabled)) {
                onStandClick(undefined);
            }
            else {
                const stand = feature.properties;
                onStandClick(stand);
                if (bound) {
                    map.fitBounds(turf.bbox(JSON.parse(stand.geoJSON)), { padding: 20, linear: true });
                }
            }
        };
        map.on('mousemove', LayerParams.standFill, onMouseMove);
        map.on('mouseleave', LayerParams.standFill, onMouseLeaveHover);
        map.on('mouseenter', LayerParams.standFill, onMouseEnter);
        map.on('mouseleave', LayerParams.standFill, onMouseLeave);
        map.on('click', LayerParams.standFill, onClick);
        return () => {
            map.off('mousemove', LayerParams.standFill, onMouseMove);
            map.off('mouseleave', LayerParams.standFill, onMouseLeaveHover);
            map.off('mouseenter', LayerParams.standFill, onMouseEnter);
            map.off('mouseleave', LayerParams.standFill, onMouseLeave);
            map.off('click', LayerParams.standFill, onClick);
        };
    }, [map, onStandClick, baseLayerChangedNum]);
};
export default useStandClick;
